import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-edit-page-search-dropdown',
    templateUrl: './edit-page-search-dropdown.component.html',
    styleUrls: ['./edit-page-search-dropdown.component.scss'],
    standalone: false
})
export class EditPageSearchDropdownComponent {
    readonly CLICK_EVENT = 'click';

    @Input() placeholder!: string;
    @Input() subTitle!: string;
    @Input() value!: string;
    @Input() maxlength!: number;
    
    @Output() onValueChange = new EventEmitter();
    @Output() onItemClick = new EventEmitter();

    public inputFocus = false;
    public showItemList = false;

    constructor(
        private cdr: ChangeDetectorRef
    ) {}

    onInputFocus() {
        this.inputFocus = true;
        this.showItemList = true;
    }

    onInputBlur() {
        this.inputFocus = false;
        document.addEventListener(this.CLICK_EVENT, this.onDocumentClick);
    }

    onInputChage() {
        this.onValueChange.emit(this.value);
    }

    onInputKeyDown(e: KeyboardEvent) {
        if(e.key === 'Enter') {
            this.showItemList = false;
        }else {
            this.showItemList = true;
        }
    }

    onClick(item) {
        this.onItemClick.emit(item);
    }

    // Using an arrow function here to preserve the 'this' context
    onDocumentClick = () => {
        this.showItemList = false;
        document.removeEventListener(this.CLICK_EVENT, this.onDocumentClick);
        this.cdr.detectChanges();
    }
}
